var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { animate, keyframes, style, transition, trigger, } from "@angular/animations";
import { FlexibleConnectedPositionStrategy, Overlay, OverlayConfig, ScrollDispatcher, } from "@angular/cdk/overlay";
import { CdkPortal, Portal } from "@angular/cdk/portal";
import { DOCUMENT } from "@angular/common";
import { ChangeDetectorRef, EventEmitter, Renderer2, } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { RepetitiveSubscription } from "@topyourthree/decorators";
import { TimeUtils } from "@topyourthree/time-utils";
import { assertNever, toNumber } from "@topyourthree/utils";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime, filter } from "rxjs/operators";
import { TESTING_CLOSE_ANIMATION_DISABLED } from "../ui.config";
import { CalloutColor } from "./callout-color";
import { bottomCenter, bottomLeft, bottomRight, leftBottom, leftCenter, leftTop, rightBottom, rightCenter, rightTop, topCenter, topLeft, topRight, } from "./callout-connected-position";
import { CalloutContentComponent } from "./callout-content.component";
import { CalloutPlacement } from "./callout-placement";
import { CalloutSize } from "./callout-size";
import { CalloutTriggerComponent } from "./callout-trigger.component";
import { CalloutService } from "./callout.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
import * as i2 from "@topyourthree/time-utils";
import * as i3 from "@angular/router";
import * as i4 from "./callout.service";
import * as i5 from "@angular/common";
import * as i6 from "@angular/cdk/portal";
const _c0 = [[["fl-callout-trigger"]], [["fl-callout-content"]]];
const _c1 = ["fl-callout-trigger", "fl-callout-content"];
function CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Conditional_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 5);
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const calloutContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", calloutContent_r3);
} }
function CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("@paneAnimation.done", function CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Template_div_animation_paneAnimation_done_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.animationDone($event)); });
    i0.ɵɵtemplate(1, CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Conditional_1_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("AngularAnimation", !ctx_r1.isMobileView() || !ctx_r1.useSlideAnimation);
    i0.ɵɵproperty("@paneAnimation", ctx_r1.getAnimationParams())("@.disabled", ctx_r1.isMobileView() || !ctx_r1.useSlideAnimation);
    i0.ɵɵattribute("data-mobile-fullscreen", ctx_r1.mobileFullscreen)("data-placement", ctx_r1.placement);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.crawlable || ctx_r1.calloutIsOpen ? 1 : -1);
} }
function CalloutComponent_ng_template_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CalloutComponent_ng_template_1_Conditional_0_Conditional_0_Template, 2, 7, "div", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.calloutIsOpen ? 0 : -1);
} }
function CalloutComponent_ng_template_1_Conditional_1_Conditional_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CalloutComponent_ng_template_1_Conditional_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CalloutComponent_ng_template_1_Conditional_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 5);
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const calloutContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", calloutContent_r3);
} }
function CalloutComponent_ng_template_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, CalloutComponent_ng_template_1_Conditional_1_Conditional_1_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-mobile-fullscreen", ctx_r1.mobileFullscreen)("data-placement", ctx_r1.placement);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.crawlable || ctx_r1.calloutIsOpen ? 1 : -1);
} }
function CalloutComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CalloutComponent_ng_template_1_Conditional_0_Template, 1, 1)(1, CalloutComponent_ng_template_1_Conditional_1_Template, 2, 3, "div", 3);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.testingCloseAnimationDisabled ? 0 : 1);
} }
function CalloutComponent_Conditional_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CalloutComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CalloutComponent_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const calloutContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", calloutContent_r3);
} }
function CalloutComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
} }
export class CalloutComponent {
    constructor(renderer, changeDetectorRef, overlay, scrollDispatcher, timeUtils, router, calloutService, document, 
    /** This should only be injected in UI tests */
    testingCloseAnimationDisabled) {
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        this.overlay = overlay;
        this.scrollDispatcher = scrollDispatcher;
        this.timeUtils = timeUtils;
        this.router = router;
        this.calloutService = calloutService;
        this.document = document;
        this.testingCloseAnimationDisabled = testingCloseAnimationDisabled;
        this.color = CalloutColor.LIGHT;
        this.bigBorderRadius = false; // We added this so that we match the radius of the containers in Messaging Redesign
        this.edgeToEdge = false;
        this.hideArrow = false;
        this.hideCloseButton = false;
        this.hover = false;
        this.placement = CalloutPlacement.BOTTOM;
        this.useSlideAnimation = false;
        this.mobileCloseButton = true;
        this.delay = 0;
        /* Allows use overflow visible if is need it */
        this.overflowContent = false;
        /**
         * Will embed the callout content in the DOM (but hidden), when the callout is close.
         * Use if you want the content to crawlable for SEO purposes.
         */
        this.crawlable = false;
        /**
         * Show a backdrop, only applicable in tablet view and bigger.
         * Backdrop is always displayed in mobile view unless the callout is hidden for mobile.
         */
        this.backdrop = false;
        /** Use when content is scrollable for a better mobile experience. */
        this.mobileFullscreen = false;
        /**
         * Use when callout is hoverable and clicking on the trigger performs an action.
         * This allow mobile devices to trigger callout after pressing for 500ms.
         * It is important to note that callout will not be triggered on desktop with
         * mobile viewport as opening the dialog will break the flow of the trigger's
         * original action.
         */
        this.mobileLongPress = false;
        /**
         * Forces callout to open on tap/click. Useful when callout
         * trigger is a clickable element but is disabled. Use `mobileLongPress`
         * whenever possible.
         */
        this.mobileForceClick = false;
        this.mobileDropdown = false;
        this.hideMobile = false;
        /**
         * Used to set the offset of the callout from the trigger.
         * This is useful when the trigger is inline with other elements.
         */
        this.calloutOffsetInPixel = 4;
        /**
         * Allows the callout to be pushed into view and adjust its dimensions
         * to ensure it fits within the viewport. Useful for wide callouts that might
         * otherwise get cut off.
         */
        this.viewportFit = { enabled: false };
        this.calloutClose = new EventEmitter();
        this.calloutOpen = new EventEmitter();
        this.calloutNeedsToBeClosed = true;
        this.canRemoveOverflow = false;
        /**
         * Whether the callout has been opened by clicking.
         * Hover callouts can be forced to stay open by
         * clicking on the trigger
         */
        this.isOpenedOnClick = false;
        this.isFullscreenMode = false;
        this.calloutIsOpen = false;
    }
    // TODO: T267853 - The way we handle states of when a callout needs to be
    // closed or opened during a hover transition from the trigger
    // to the callout content is pretty all over the place. When
    // somebody has time (and clarity to think) redo the logic again.
    // Ref: T37940.
    ngOnInit() {
        if (this.hideMobile) {
            this.backdrop = false;
        }
        this.triggerComponent.setOptions({
            hover: this.hover,
            mobileForceClick: this.mobileForceClick,
            mobileLongPress: this.mobileLongPress,
        });
        this.documentClickEvent = this.renderer.listen("document", "click", () => {
            if (this.calloutNeedsToBeClosed) {
                this.closeCallout();
            }
            this.calloutNeedsToBeClosed = true;
        });
        this.triggerComponentTrigger = this.triggerComponent.trigger.subscribe(() => {
            this.toggleCallout();
        });
        if (this.hover) {
            this.triggerComponentOpen = this.triggerComponent.open.subscribe((event) => {
                if (this.calloutIsOpen && this.isOpenedOnClick) {
                    return;
                }
                this.calloutNeedsToBeClosed = false;
                this.isOpenedOnClick = !!event?.isPinnedOnClick;
                this.delayedOpenCallout();
            });
            this.triggerComponentClose = this.triggerComponent.close.subscribe(() => {
                if (!this.isOpenedOnClick) {
                    this.calloutNeedsToBeClosed = true;
                    this.checkIfCalloutNeedsClosing();
                }
            });
        }
        this.routeChangeSubscription = this.router.events
            .pipe(filter((event) => {
            const isReplaceUrl = this.router.getCurrentNavigation()?.extras?.replaceUrl ?? false;
            return event instanceof NavigationStart && !isReplaceUrl;
        }))
            .subscribe(() => {
            this.close();
        });
        this.previousViewportWidth = window.innerWidth;
        this.resizeSubscription = fromEvent(window, "resize")
            .pipe(debounceTime(100))
            .subscribe(() => {
            const currentViewportWidth = window.innerWidth;
            if (currentViewportWidth === this.previousViewportWidth) {
                return;
            }
            this.previousViewportWidth = currentViewportWidth;
            if (!this.calloutIsOpen) {
                return;
            }
            // クリック固定状態を解除して強制的に閉じる
            this.isOpenedOnClick = false;
            this.closeCallout();
        });
        this.currentPlacement =
            this.placement === "top" || this.placement === "bottom"
                ? {
                    overlayX: "center",
                    overlayY: this.placement === "top" ? "bottom" : "top",
                    anchor: "overlayY",
                }
                : {
                    overlayX: this.placement === "start" ? "end" : "start",
                    overlayY: "center",
                    anchor: "overlayX",
                };
    }
    ngOnChanges(changes) {
        if (("hideMobile" in changes || "backdrop" in changes) && this.hideMobile) {
            this.backdrop = false;
        }
    }
    // Allow animation to finish before disposing the overlay
    animationDone(event) {
        if (event.toState === "void") {
            this.overlayRef.dispose();
        }
    }
    open() {
        this.delayedOpenCallout();
    }
    close() {
        this.closeCallout();
    }
    toggle() {
        this.toggleCallout();
    }
    /**
     * Use this only if you move the callout trigger around
     */
    updatePosition() {
        this.overlayRef.updatePosition();
    }
    checkIfTriggerIsInView() {
        const triggerBoundingRect = this.triggerComponent.getElementBoundingRect();
        return (triggerBoundingRect.top >= 0 &&
            triggerBoundingRect.left >= 0 &&
            triggerBoundingRect.right <=
                (window.innerWidth || document.documentElement.clientWidth) &&
            triggerBoundingRect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight));
    }
    toggleCallout() {
        if (this.calloutIsOpen) {
            this.closeCallout();
        }
        else {
            this.delayedOpenCallout();
        }
    }
    openCallout() {
        if (this.hover) {
            this.calloutService.activateHover(this);
        }
        this.isFullscreenMode = this.isMobileView() && this.mobileFullscreen;
        this.calloutIsOpen = true;
        this.overlayRef = this.createOverlay();
        this.overlayRef.attach(this.portal);
        this.contentComponent.setOptions({
            bigBorderRadius: this.bigBorderRadius,
            color: this.color,
            edgeToEdge: this.edgeToEdge,
            hideArrow: this.hideArrow,
            hideCloseButton: this.hideCloseButton,
            hover: this.hover,
            mobileCloseButton: this.mobileCloseButton,
            mobileFullscreen: this.mobileFullscreen,
            mobileHeaderTitle: this.mobileHeaderTitle,
            overflowContent: this.overflowContent,
            size: this.size,
            triggerHtmlElement: this.triggerComponent.nativeElement,
        });
        this.contentComponent.setPlacement(this.currentPlacement, this.triggerComponent.containerRef.element.nativeElement);
        this.setCalloutZIndex();
        this.calloutNeedsToBeClosed = false;
        this.contentComponentClose = this.contentComponent.close.subscribe(() => this.closeCallout());
        this.contentComponentBodyClick = this.contentComponent.bodyClick.subscribe(() => {
            this.calloutNeedsToBeClosed = false;
        });
        if (this.hover) {
            this.contentComponentBodyMouseenter =
                this.contentComponent.bodyMouseenter.subscribe(() => {
                    if (!this.isOpenedOnClick) {
                        this.calloutNeedsToBeClosed = false;
                    }
                });
            this.contentComponentBodyMouseleave =
                this.contentComponent.bodyMouseleave.subscribe(() => {
                    if (!this.isOpenedOnClick) {
                        this.calloutNeedsToBeClosed = true;
                        this.checkIfCalloutNeedsClosing();
                    }
                });
        }
        this.togglePageScrollState(this.calloutIsOpen);
        this.calloutOpen.emit();
    }
    delayedOpenCallout() {
        if (this.calloutIsOpen) {
            return;
        }
        // T293469: Disable delayed open in the testing environment, as it causes
        // an animation listener binding error in the UI tests for the Find page.
        if (!this.delay || this.testingCloseAnimationDisabled) {
            this.openCallout();
        }
        else {
            this.timeUtils.setTimeout(() => this.openCallout(), this.delay);
        }
    }
    checkIfCalloutNeedsClosing() {
        this.timeUtils.setTimeout(() => {
            if (this.calloutNeedsToBeClosed) {
                this.closeCallout();
            }
        }, 100);
    }
    closeCallout() {
        if (this.calloutIsOpen) {
            this.detachOverlay();
            if (this.isMobileView() || this.testingCloseAnimationDisabled) {
                // Detach immediately if the animation flag is provided as the `animationDone`
                // callback timing is later than expected in in consecutive UI tests.
                this.overlayRef.dispose();
            }
            this.calloutIsOpen = false;
            this.calloutNeedsToBeClosed = true;
            if (this.contentComponentClose) {
                this.contentComponentClose.unsubscribe();
            }
            if (this.contentComponentBodyClick) {
                this.contentComponentBodyClick.unsubscribe();
            }
            if (this.hover) {
                if (this.contentComponentBodyMouseenter) {
                    this.contentComponentBodyMouseenter.unsubscribe();
                }
                if (this.contentComponentBodyMouseleave) {
                    this.contentComponentBodyMouseleave.unsubscribe();
                }
            }
            this.togglePageScrollState(this.calloutIsOpen);
            this.calloutClose.emit();
        }
    }
    detachOverlay() {
        if (!this.overlayRef.hasAttached()) {
            return;
        }
        // clean up zIndex hacking on the global callout parent
        // the `hostElement` itself is destroyed after detaching
        // so we don't need to worry about it
        if (this.overlayRef.hostElement.parentElement) {
            this.overlayRef.hostElement.parentElement.style.zIndex = "9001";
        }
        this.overlayRef.detach();
        if (this.positionChangeSubscription) {
            this.positionChangeSubscription.unsubscribe();
        }
    }
    /**
     * Calculates the effective z-index of the trigger component,
     * then sets the z-index of the content to be just above.
     */
    setCalloutZIndex() {
        // don't do any z-index trickery for mobile dialogs or if backdrop is set
        // as both dialogs and fullscreen callouts should always be on top
        if (this.isMobileDialog() || this.backdrop) {
            return;
        }
        // loop through the parent elements until we find one with a defined z-index
        // it's a bit gross but there's no easy one-call function to get applied z-index
        let currElement = this.triggerComponent.containerRef.element.nativeElement;
        let currZIndex = window.getComputedStyle(currElement).zIndex;
        let effectiveZIndex = toNumber(currZIndex) || 0;
        while (currElement.parentElement) {
            currElement = currElement.parentElement;
            currZIndex = window.getComputedStyle(currElement).zIndex;
            effectiveZIndex = Math.max(effectiveZIndex, toNumber(currZIndex) || 0);
        }
        this.contentComponent.zIndex = effectiveZIndex + 11;
        // set the parent zIndexes as well to override the Material styles
        // which by default would cause it to sit above nav/messaging/etc.
        if (this.overlayRef.hostElement.parentElement) {
            this.overlayRef.hostElement.style.zIndex = `${effectiveZIndex + 11}`;
            this.overlayRef.hostElement.parentElement.style.zIndex = `${effectiveZIndex + 11}`;
            this.overlayRef.overlayElement.style.zIndex = `${effectiveZIndex + 11}`;
        }
    }
    /**
     * Prevents body from scrolling on mobile if
     * it becomes a dialog with overlay
     */
    togglePageScrollState(isCalloutOpen) {
        const target = this.document.body;
        const currentOverflow = target.style.overflow;
        // We only want to remove overflow when callout component is the
        // one that set it. For instance, when callout is placed within a modal
        // overflow is already set and we don't want to remove it
        // once callout is closed
        if (isCalloutOpen && !currentOverflow) {
            this.canRemoveOverflow = true;
        }
        if (isCalloutOpen && this.isMobileDialog()) {
            this.renderer.setStyle(target, "overflow", "hidden");
        }
        else if (!isCalloutOpen && this.canRemoveOverflow) {
            this.renderer.removeStyle(target, "overflow");
            this.canRemoveOverflow = false;
        }
    }
    // Need to remove private for D213925
    isMobileView() {
        return false;
        return (window.innerWidth < parseInt("0px" /* TopYourThreeBreakpointValues.TABLET */, 10));
    }
    /**
     * Whether this modal pops up on mobile as a dialog,
     * with a backdrop + not tethered to the element.
     *
     * Also includes fullscreen ones.
     */
    isMobileDialog() {
        return this.isMobileView() && !this.hideMobile && !this.mobileDropdown;
    }
    ngOnDestroy() {
        this.resizeSubscription?.unsubscribe();
        this.closeCallout();
        if (this.overlayRef) {
            this.detachOverlay();
            this.overlayRef.dispose();
        }
        if (this.documentClickEvent) {
            this.documentClickEvent();
        }
        if (this.triggerComponentTrigger) {
            this.triggerComponentTrigger.unsubscribe();
        }
        if (this.hover) {
            if (this.triggerComponentOpen) {
                this.triggerComponentOpen.unsubscribe();
            }
            if (this.triggerComponentClose) {
                this.triggerComponentClose.unsubscribe();
            }
        }
        if (this.routeChangeSubscription) {
            this.routeChangeSubscription.unsubscribe();
        }
        if (this.positionChangeSubscription) {
            this.positionChangeSubscription.unsubscribe();
        }
    }
    /**
     * Returns the connection offset for the callout.
     * We add a little bit of an offset to put a gap between the arrow and trigger.
     *
     * TODO: remove - I'm only adding this now to mantain legacy UI and make sure
     * that the screenshot tests pass properly.
     *
     * FIXME: not setting the offset causes the close button to be mispositioned
     * Even a `translate(0px)` somehow fixes it, but passing 0 does not set that,
     * so we have to have some offset gap.
     */
    getOffset() {
        const anchor = this.currentPlacement[this.currentPlacement.anchor];
        return {
            offsetX: anchor === "start"
                ? this.calloutOffsetInPixel
                : anchor === "end"
                    ? -this.calloutOffsetInPixel
                    : 0,
            offsetY: anchor === "top"
                ? this.calloutOffsetInPixel
                : anchor === "bottom"
                    ? -this.calloutOffsetInPixel
                    : 0,
        };
    }
    getPositions() {
        const offset = this.getOffset();
        const topPositions = [
            { ...topCenter },
            { ...topLeft },
            { ...topRight },
            { ...bottomCenter },
            { ...bottomLeft },
            { ...bottomRight },
        ];
        const bottomPositions = [
            { ...bottomCenter },
            { ...bottomLeft },
            { ...bottomRight },
            { ...topCenter },
            { ...topLeft },
            { ...topRight },
        ];
        const leftPositions = [
            { ...leftCenter },
            { ...leftBottom },
            { ...leftTop },
        ];
        const rightPositions = [
            { ...rightCenter },
            { ...rightBottom },
            { ...rightTop },
        ];
        const rightBottomPositions = [
            { ...rightBottom },
            { ...rightTop },
        ];
        const rightTopPositions = [
            { ...rightTop },
            { ...rightBottom },
        ];
        const bottomLeftPositions = [
            { ...bottomLeft },
            { ...topLeft },
        ];
        const bottomRightPositions = [
            { ...bottomRight },
            { ...topRight },
        ];
        switch (this.placement) {
            case CalloutPlacement.TOP:
                return [...topPositions, ...bottomPositions].map((pos) => ({
                    ...pos,
                    offsetY: offset.offsetY,
                }));
            case CalloutPlacement.BOTTOM:
                return [...bottomPositions, ...topPositions].map((pos) => ({
                    ...pos,
                    offsetY: offset.offsetY,
                }));
            case CalloutPlacement.LEFT:
                return [...leftPositions, ...rightPositions].map((pos) => ({
                    ...pos,
                    offsetX: offset.offsetX,
                }));
            case CalloutPlacement.RIGHT:
                return [...rightPositions, ...leftPositions].map((pos) => ({
                    ...pos,
                    offsetX: offset.offsetX,
                }));
            case CalloutPlacement.BOTTOM_LEFT:
                return [...bottomLeftPositions, ...topPositions].map((pos) => ({
                    ...pos,
                    offsetY: offset.offsetY,
                }));
            case CalloutPlacement.BOTTOM_RIGHT:
                return [...bottomRightPositions, ...topPositions].map((pos) => ({
                    ...pos,
                    offsetY: offset.offsetY,
                }));
            case CalloutPlacement.RIGHT_BOTTOM:
                return [...rightBottomPositions, ...leftPositions].map((pos) => ({
                    ...pos,
                    offsetX: offset.offsetX,
                }));
            case CalloutPlacement.RIGHT_TOP:
                return [...rightTopPositions, ...leftPositions].map((pos) => ({
                    ...pos,
                    offsetX: offset.offsetX,
                }));
            default:
                assertNever(this.placement);
        }
    }
    updateCalloutArrowPosition(connectionPair) {
        const prevAnchorPosition = this.currentPlacement.anchor;
        this.currentPlacement = { ...connectionPair, anchor: prevAnchorPosition };
        this.contentComponent.setPlacement(this.currentPlacement, this.triggerComponent.containerRef.element.nativeElement);
        this.changeDetectorRef.markForCheck();
    }
    getSize() {
        switch (this.size) {
            case CalloutSize.MEDIUM:
                return 400;
            case CalloutSize.SMALL:
                return 270;
            default:
                // default: undefined (determined by size of content)
                return undefined;
        }
    }
    createOverlay() {
        const positions = this.getPositions();
        this.currentPlacement = {
            ...positions[1],
            anchor: ["top", "bottom", "bottom-left", "bottom-right"].includes(this.placement)
                ? "overlayY"
                : "overlayX",
        };
        // Reposition callout when scrolled
        const scrollStrategy = this.overlay.scrollStrategies.block();
        let positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.triggerComponent.containerRef.element)
            .withPositions(positions)
            // Only enable push and flexible dimensions if ensureViewportFit is true
            .withPush(this.viewportFit.enabled)
            .withFlexibleDimensions(this.viewportFit.enabled)
            .withViewportMargin(this.viewportFit.enabled
            ? (this.viewportFit.options?.viewportMargin ?? 0)
            : 0)
            .withScrollableContainers(this.scrollDispatcher.getAncestorScrollContainers(this.triggerComponent.containerRef.element));
        if (this.isMobileDialog()) {
            positionStrategy = this.overlay.position().global();
            if (this.mobileFullscreen) {
                positionStrategy = positionStrategy
                    .left("0")
                    .top("0");
            }
            else {
                positionStrategy = positionStrategy
                    .centerHorizontally()
                    .centerVertically();
            }
        }
        const width = this.isMobileView()
            ? this.mobileFullscreen
                ? // mobile and mobileFullscreen: fullscreen width
                    "100%"
                : // mobile but not mobileFullscreen: dialog filling most of the screen
                    this.mobileDropdown
                        ? this.getSize()
                        : "90%"
            : // non-mobile: set size if CalloutSize is set
                this.getSize();
        const height = this.isMobileView() && this.mobileFullscreen ? "100%" : undefined;
        const state = new OverlayConfig({
            hasBackdrop: this.isMobileDialog() || this.backdrop,
            height,
            width,
            positionStrategy,
            scrollStrategy,
        });
        if (positionStrategy instanceof FlexibleConnectedPositionStrategy) {
            this.positionChangeSubscription =
                positionStrategy.positionChanges.subscribe((change) => {
                    this.updateCalloutArrowPosition(change.connectionPair);
                });
        }
        return this.overlay.create(state);
    }
    getAnimationParams() {
        switch (this.placement) {
            case "top":
                return {
                    value: "",
                    params: {
                        transform: "translateY(-10px)",
                        bounceTransform: "translateY(10px)",
                    },
                };
            case "bottom":
            case "bottom-left":
            case "bottom-right":
                return {
                    value: "",
                    params: {
                        transform: "translateY(10px)",
                        bounceTransform: "translateY(-10px)",
                    },
                };
            case "start":
                return {
                    value: "",
                    params: {
                        transform: "translateX(-10px)",
                        bounceTransform: "translateX(10px)",
                    },
                };
            case "end":
            case "end-bottom":
            case "end-top":
                return {
                    value: "",
                    params: {
                        transform: "translateX(10px)",
                        bounceTransform: "translateX(-10px)",
                    },
                };
            default:
                return {
                    value: "",
                    params: {
                        transform: "translateY(10px)",
                        bounceTransform: "translateY(-10px)",
                    },
                };
        }
    }
}
CalloutComponent.ɵfac = function CalloutComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CalloutComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i1.ScrollDispatcher), i0.ɵɵdirectiveInject(i2.TimeUtils), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.CalloutService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(TESTING_CLOSE_ANIMATION_DISABLED, 8)); };
CalloutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CalloutComponent, selectors: [["fl-callout"]], contentQueries: function CalloutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, CalloutTriggerComponent, 7);
        i0.ɵɵcontentQuery(dirIndex, CalloutContentComponent, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentComponent = _t.first);
    } }, viewQuery: function CalloutComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CdkPortal, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.portal = _t.first);
    } }, inputs: { color: "color", bigBorderRadius: "bigBorderRadius", edgeToEdge: "edgeToEdge", hideArrow: "hideArrow", hideCloseButton: "hideCloseButton", hover: "hover", placement: "placement", size: "size", useSlideAnimation: "useSlideAnimation", mobileCloseButton: "mobileCloseButton", delay: "delay", overflowContent: "overflowContent", crawlable: "crawlable", backdrop: "backdrop", mobileFullscreen: "mobileFullscreen", mobileLongPress: "mobileLongPress", mobileForceClick: "mobileForceClick", mobileHeaderTitle: "mobileHeaderTitle", mobileDropdown: "mobileDropdown", hideMobile: "hideMobile", calloutOffsetInPixel: "calloutOffsetInPixel", viewportFit: "viewportFit" }, outputs: { calloutClose: "calloutClose", calloutOpen: "calloutOpen" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 5, vars: 1, consts: [["calloutContent", ""], ["cdk-portal", ""], [3, "hidden"], [1, "ContentContainer"], [1, "ContentContainer", 3, "AngularAnimation"], [4, "ngTemplateOutlet"]], template: function CalloutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵprojection(0);
        i0.ɵɵtemplate(1, CalloutComponent_ng_template_1_Template, 2, 1, "ng-template", 1)(2, CalloutComponent_Conditional_2_Template, 2, 2, "div", 2)(3, CalloutComponent_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.crawlable && !ctx.calloutIsOpen ? 2 : -1);
    } }, dependencies: [i5.NgTemplateOutlet, i6.TemplatePortalDirective], styles: [".ContentContainer[_ngcontent-%COMP%]{width:100%}.ContentContainer[data-placement=bottom-left][_ngcontent-%COMP%]{transform-origin:top left}.ContentContainer[data-placement=bottom-right][_ngcontent-%COMP%]{transform-origin:top right}.ContentContainer[data-placement=bottom-center][_ngcontent-%COMP%]{transform-origin:top center}.ContentContainer[data-placement=top-left][_ngcontent-%COMP%]{transform-origin:bottom left}.ContentContainer[data-placement=top-right][_ngcontent-%COMP%]{transform-origin:bottom right}.ContentContainer[data-placement=top-center][_ngcontent-%COMP%]{transform-origin:bottom center}.ContentContainer[data-placement=left-center][_ngcontent-%COMP%]{transform-origin:center right}.ContentContainer[data-placement=right-center][_ngcontent-%COMP%]{transform-origin:center left}.AngularAnimation[_ngcontent-%COMP%]{position:relative}@media(prefers-reduced-motion: no-preference){.ContentContainer[_ngcontent-%COMP%]{animation:.1s ease-out growOut}}@keyframes _ngcontent-%COMP%_growOut{0%{opacity:0;transform:scale(0.95)}50%{opacity:1;transform:scale(1.02)}100%{opacity:1;transform:scale(1)}}.ContentContainer[data-mobile-fullscreen=true][_ngcontent-%COMP%]{width:100%;height:100%;max-height:100%;border-radius:0;margin:0}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9AdG9weW91cnRocmVlL3VpL2NhbGxvdXQvY2FsbG91dC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRQSxrQkFDRSxVQUFBLENBR0EsOENBQ0UseUJBQUEsQ0FJRiwrQ0FDRSwwQkFBQSxDQUdGLGdEQUNFLDJCQUFBLENBR0YsMkNBQ0UsNEJBQUEsQ0FHRiw0Q0FDRSw2QkFBQSxDQUdGLDZDQUNFLDhCQUFBLENBR0YsOENBQ0UsNkJBQUEsQ0FHRiwrQ0FDRSw0QkFBQSxDQU9KLGtCQUNFLGlCQUFBLENBT0YsOENBQ0Usa0JBQ0UsOEJBQUEsQ0FBQSxDQUtKLG1CQUNFLEdBQ0UsU0FBQSxDQUNBLHFCQUFBLENBR0YsSUFDRSxTQUFBLENBQ0EscUJBQUEsQ0FHRixLQUNFLFNBQUEsQ0FDQSxrQkFBQSxDQUFBLENBUUosK0NBQ0UsVUFBQSxDQUNBLFdBQUEsQ0FDQSxlQUFBLENBQ0EsZUFBQSxDQUNBLFFBQUEiLCJzb3VyY2VzQ29udGVudCI6WyIvKiA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiAqICBmbC1jYWxsb3V0IChjYWxsb3V0LmNvbXBvbmVudC5zY3NzIMOmwo7CqMOmwrjCrMOlwq7CjMOlwoXCqMOnwonCiCA3MCUpXG4gKiA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiAqL1xuXG4vKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gIMOlwp/CusOmwpzCrMOjwoPCrMOjwoLCpMOjwoLCosOjwoLCpsOjwoPCiFxuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0qL1xuLkNvbnRlbnRDb250YWluZXIge1xuICB3aWR0aDogMTAwJTtcblxuICAvKiBkYXRhLXBsYWNlbWVudCDDo8KBwqvDo8KCwojDo8KCwovDpMK9wo3Dp8K9wq7DqMKqwr/DpsKVwrTDr8K8woh0cmFuc2Zvcm0tb3JpZ2luw6/CvMKJICovXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJib3R0b20tbGVmdFwiXSB7XG4gICAgdHJhbnNmb3JtLW9yaWdpbjogdG9wIGxlZnQ7XG4gIH1cblxuICAvKiDDpMK7wpbDo8KBwq4gcGxhY2VtZW50IMOjwoHCr8OjwoHCk8OjwoHCrsOjwoLCiMOjwoHChsOjwoHCq8Olwq3CmMOlwpzCqMOjwoHCmcOjwoLCi8OjwoHCr8OjwoHCmsOvwrzCiFRPRE86IERldlRvb2xzw6PCgcKnw6fCosK6w6jCqsKNw6/CvMKJICovXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJib3R0b20tcmlnaHRcIl0ge1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IHRvcCByaWdodDtcbiAgfVxuXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJib3R0b20tY2VudGVyXCJdIHtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiB0b3AgY2VudGVyO1xuICB9XG5cbiAgJltkYXRhLXBsYWNlbWVudD1cInRvcC1sZWZ0XCJdIHtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiBib3R0b20gbGVmdDtcbiAgfVxuXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJ0b3AtcmlnaHRcIl0ge1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IGJvdHRvbSByaWdodDtcbiAgfVxuXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJ0b3AtY2VudGVyXCJdIHtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiBib3R0b20gY2VudGVyO1xuICB9XG5cbiAgJltkYXRhLXBsYWNlbWVudD1cImxlZnQtY2VudGVyXCJdIHtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiBjZW50ZXIgcmlnaHQ7XG4gIH1cblxuICAmW2RhdGEtcGxhY2VtZW50PVwicmlnaHQtY2VudGVyXCJdIHtcbiAgICB0cmFuc2Zvcm0tb3JpZ2luOiBjZW50ZXIgbGVmdDtcbiAgfVxufVxuXG4vKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gIEFuZ3VsYXIgw6PCgsKiw6PCg8KLw6PCg8Khw6PCg8K8w6PCgsK3w6PCg8Knw6PCg8Kzw6fClMKow6PCgsKvw6PCg8Kpw6PCgsK5XG4tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSovXG4uQW5ndWxhckFuaW1hdGlvbiB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLyotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICDDo8KCwqLDo8KDwovDo8KDwqHDo8KDwrzDo8KCwrfDo8KDwqfDo8KDwrPDr8K8wohncm93T3V0w6/CvMKJXG4tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSovXG5cbkBtZWRpYSAocHJlZmVycy1yZWR1Y2VkLW1vdGlvbjogbm8tcHJlZmVyZW5jZSkge1xuICAuQ29udGVudENvbnRhaW5lciB7XG4gICAgYW5pbWF0aW9uOiAwLjFzIGVhc2Utb3V0IGdyb3dPdXQ7XG4gIH1cbn1cblxuLyogZ3Jvd091dCDDo8KBwq7DpsKOwqjDpsK4wqzDr8K8wojDpcKuwp9DU1PDo8KBwq/Dp8KiwrrDqMKqwo3DpcK/woXDqMKmwoHDr8K8wokgKi9cbkBrZXlmcmFtZXMgZ3Jvd091dCB7XG4gIDAlIHtcbiAgICBvcGFjaXR5OiAwO1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMC45NSk7XG4gIH1cblxuICA1MCUge1xuICAgIG9wYWNpdHk6IDE7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxLjAyKTtcbiAgfVxuXG4gIDEwMCUge1xuICAgIG9wYWNpdHk6IDE7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxKTtcbiAgfVxufVxuXG4vKi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tXG4gIMOjwoPCosOjwoPCkMOjwoLCpMOjwoPCq8OjwoPClcOjwoPCq8OjwoLCucOjwoLCr8OjwoPCqsOjwoPCvMOjwoPCs8Olwq/CvsOlwr/CnMOvwrzCiMOmwo7CqMOmwrjCrMOvwrzCiVxuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0qL1xuXG4uQ29udGVudENvbnRhaW5lcltkYXRhLW1vYmlsZS1mdWxsc2NyZWVuPVwidHJ1ZVwiXSB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG1heC1oZWlnaHQ6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IDA7XG4gIG1hcmdpbjogMDtcbiAgLyogVE9ETzogRGV2VG9vbHMgw6PCgcKnw6fCosK6w6jCqsKNICovXG59XG5cbi8qLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAgRWRnZS10by1lZGdlIMOlwq/CvsOlwr/CnCAoY2FsbG91dC1jb250ZW50LmNvbXBvbmVudC5zY3Nzw6XCgcK0w6PCgcKrw6PCgsKCw6PCgcKCw6PCgsKLKVxuLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0qL1xuLkNvbnRlbnRDb250YWluZXJbZGF0YS1lZGdlLXRvLWVkZ2U9XCJ0cnVlXCJdIHtcbiAgLyogw6PCgsKzw6PCg8Kzw6PCg8KGw6PCg8KKw6PCgcKvMTAwJcOlwrnChcOjwoHCrsOjwoHCvsOjwoHCvsOjwoHCrsOlwo/Cr8OowoPCvcOmwoDCp8OlwqTCpyAqL1xuICAvKiBUT0RPOiBUb3BZb3VyVGhyZWXDo8KBwqfDo8KBwq8gcGFkZGluZyDDo8KBwq8gQ2FsbG91dEJvZHkgw6XCgcK0w6PCgcKnw6bCtsKIw6PCgcKIw6PCgsKLICovXG59XG5cbi8qLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1cbiAgw6PCg8Kiw6PCg8KQw6PCgsKkw6PCg8Krw6PCgcKnw6PCgcKuIHNsaWRlIGFuaW1hdGlvbiDDp8KUwqjDr8K8wojDpsKOwqjDpsK4wqzDr8K8wolcbi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tKi9cbi5Db250ZW50Q29udGFpbmVyW2RhdGEtc2xpZGUtYW5pbWF0aW9uPVwidHJ1ZVwiXSB7XG4gIC8qIFRPRE86IHVzZVNsaWRlQW5pbWF0aW9uPXRydWUgw6PCgcKuw6XCoMK0w6XCkMKIw6PCgcKuIENTUyDDo8KCwpLDp8KiwrrDqMKqwo3Do8KBwpnDo8KBwrnDo8KBwo0gKi9cbn1cblxuLyotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVxuICBCYWNrZHJvcCDDqMKhwqjDp8KkwrrDpsKZwoJcbi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tKi9cbi5Db250ZW50Q29udGFpbmVyW2RhdGEtYmFja2Ryb3A9XCJ0cnVlXCJdIHtcbiAgLyogVE9ETzogb3ZlcmxheSDDo8KBwq4gQ1NTIMOjwoHCjMOlwoXCpcOjwoLCi8Olwo/Cr8OowoPCvcOmwoDCp8OjwoHCgsOjwoLCiiAqL1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */"], data: { animation: [
            trigger("paneAnimation", [
                transition(":enter", animate("200ms ease-in-out", keyframes([
                    style({ opacity: 0, transform: "{{transform}}", offset: 0 }),
                    style({
                        opacity: 1,
                        transform: "{{bounceTransform}}",
                        offset: 0.5,
                    }),
                    style({ opacity: 1, transform: "none", offset: 1 }),
                ]))),
                transition(":leave", [
                    animate("200ms ease-in-out", style({ opacity: 0, transform: "{{transform}}" })),
                ]),
            ]),
        ] }, changeDetection: 0 });
__decorate([
    RepetitiveSubscription(),
    __metadata("design:type", Subscription)
], CalloutComponent.prototype, "contentComponentClose", void 0);
__decorate([
    RepetitiveSubscription(),
    __metadata("design:type", Subscription)
], CalloutComponent.prototype, "contentComponentBodyClick", void 0);
__decorate([
    RepetitiveSubscription(),
    __metadata("design:type", Subscription)
], CalloutComponent.prototype, "contentComponentBodyMouseenter", void 0);
__decorate([
    RepetitiveSubscription(),
    __metadata("design:type", Subscription)
], CalloutComponent.prototype, "contentComponentBodyMouseleave", void 0);
__decorate([
    RepetitiveSubscription(),
    __metadata("design:type", Subscription)
], CalloutComponent.prototype, "positionChangeSubscription", void 0);
